import React, { useContext } from "react"

import SessionContext from "../helpers/SessionContext"
import UserMenu from "./UserMenu"

const Header = () => {
  const { session } = useContext(SessionContext)

  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <header className="border-b bg-black backdrop-blur-md sticky top-0 z-50">
        <div className="w-full px-4 py-1">
          <div className="flex items-center w-full">
            <div className="flex items-center">
              <a className="flex items-center" href="/">
                <img
                  alt="Smartrocks Logo"
                  className="h-20"
                  src={require("../images/SmartrocksLogo_White_Transparent_2.png")}
                />
              </a>
            </div>

            {session ? (
              <nav className="flex items-center justify-end space-x-6 flex-1">
                <a
                  className="text-white hover:text-slate-900 dark:text-slate-300 dark:hover:text-white font-medium"
                  href="/projects"
                >
                  Dashboard
                </a>
                <UserMenu />
              </nav>
            ) : (
              <nav className="flex items-center justify-end space-x-6 flex-1">
                <a
                  className="text-white hover:text-slate-900 dark:text-slate-300 dark:hover:text-white font-medium"
                  href="/#contact-form"
                >
                  Contact us
                </a>
                <a
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded"
                  href="/login"
                >
                  Log In
                </a>
              </nav>
            )}
          </div>
        </div>
      </header>
    </div>
  )
}

export default Header
